
export default class accessibility
{
    constructor()
    {
        let ele = $('.call-to-action-box a');

        if (ele.length) {
            this._fixHomePageHeroButton(ele);
        }
    }

    _fixHomePageHeroButton(ele)
    {
        ele.attr('aria-label', ele.text() + ' about ' + $('.large-green-text').text());
    }
}
